import { Outlet, useLocation } from 'react-router-dom';
import Nav from '../components/Layout/Nav';
import Footer from '../components/Layout/Footer';
import DetailNav from '../components/Detail/DetailNav';

const Layout = () => {
  const { pathname } = useLocation();
  const isHome = pathname === '/' || pathname === '';

  return (
    <>
      <Nav />
      {!isHome && <DetailNav place="top" />}
      <Outlet />
      {!isHome && <DetailNav place="bottom" />}
      <Footer />
    </>
  );
};

export default Layout;
